import { ChangeDetectionStrategy, Component } from '@angular/core';
import { select, Store } from '@ngrx/store';
import * as login from '../state';
import { selectAuthIdentity, selectConfigure2FA } from '@app/auth/core/state/auth.selectors';
import { TwoFACode } from '@app/auth/core/state/auth.model';
import {
  authBackToLogin,
  authClearConfigure2FAState,
  authRedirectAfterLogin,
  authSetup2FAAndLogin,
} from '@app/auth/core/state/auth.actions';
import { BackupCode } from '@app/auth/models';
import {
  login as loginAction,
  loginCheckEmailDomain,
  loginVerify2FACode,
  recoveryVerifyCode
} from '../state/login.actions';

@Component({
  selector: 'tc-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginPageComponent {
  public identity$ = this.store$.pipe(select(selectAuthIdentity));
  public configure2FA$ = this.store$.pipe(select(selectConfigure2FA));
  public loginState$ = this.store$.pipe(select(login.select.state));

  constructor(private store$: Store<login.State>) {}

  public onLogin($event: login.Credentials): void {
    this.store$.dispatch(loginAction({ payload: $event }));
  }

  public onCheckEmailDomain($event: string): void {
    this.store$.dispatch(loginCheckEmailDomain({ payload: $event }));
  }

  public onVerify2FA($event: TwoFACode): void {
    this.store$.dispatch(loginVerify2FACode({ payload: $event }));
  }

  public onVerify2FAViaRecoveryCode(event: BackupCode): void {
    this.store$.dispatch(recoveryVerifyCode(event));
  }

  onEnable2FA(event: TwoFACode): void {
    this.store$.dispatch(authSetup2FAAndLogin(event));
  }

  onBackToLogin(): void {
    this.store$.dispatch(authBackToLogin());
  }

  onClearRecoveryAndGoInside(): void {
    this.store$.dispatch(authClearConfigure2FAState());
    this.store$.dispatch(authRedirectAfterLogin({ path: '' }));
  }
}
